import { Link } from "react-router-dom";
import { channels } from "@/mocks/chigua";
import SectionHeading from "@/components/chigua/SectionHeading";

const tones = {
  primary: {
    card: "bg-primary-500",
    hover: "hover:bg-primary-600",
    chip: "bg-primary-100 text-primary-700",
  },
  accent: {
    card: "bg-accent-500",
    hover: "hover:bg-accent-600",
    chip: "bg-accent-100 text-accent-700",
  },
  secondary: {
    card: "bg-secondary-600",
    hover: "hover:bg-secondary-700",
    chip: "bg-secondary-100 text-secondary-800",
  },
};

export default function ChannelGrid() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="栏目导航"
          title="四大栏目，各取所需"
          desc="从热点速递到行业深扒，从影视幕后到粉丝生态，不同深度的内容都有一处安放。"
        />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {channels.map((c) => {
            const t = tones[c.tone];
            return (
              <Link
                key={c.slug}
                to={`/list/${c.slug}`}
                className="group relative overflow-hidden rounded-xl p-6 text-background-50 transition md:p-7"
              >
                <span className={`absolute inset-0 ${t.card} transition ${t.hover}`} aria-hidden="true" />
                <span className="pointer-events-none absolute -bottom-8 -right-6 font-display-sc text-[120px] leading-none text-background-50/10" aria-hidden="true">
                  {c.label}
                </span>
                <div className="relative">
                  <span className={`inline-flex items-center gap-1 rounded px-2 py-1 text-xs font-semibold ${t.chip}`}>
                    <i className="ri-archive-line" aria-hidden="true" />
                    {c.name}
                  </span>
                  <h3 className="mt-4 font-heading text-2xl font-bold">{c.tagline}</h3>
                  <p className="mt-3 text-sm leading-6 text-background-100">{c.intro}</p>
                  <span className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-background-50">
                    前往阅读
                    <i className="ri-arrow-right-line transition group-hover:translate-x-1" aria-hidden="true" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}